jQuery(document).ready( function($) {
    // New Events 
    var debug = false;
    
    // Phone, Email: Contact
    $('a[href^="tel:"], a[href^="sms:"]').click(function() {
        if(debug == true) { 
            console.log("FB event - Contact, tracked");
        } else { 
            fbq('track', 'Contact');
        }
    });

    // Contact Form: Contact
    var contactForm = $('#gform_1');
    contactForm.submit( function() {
        if(debug == true) { 
            console.log("FB event - Contact, tracked");
        } else { 
            fbq('track', 'Contact');
        }
    });    

    // Directions: FindLocation
    $('a[href^="https://maps.google.com/maps?saddr"]').click(function() { 
        if(debug == true) { 
            console.log("FB event - FindLocation, tracked");
        } else { 
            fbq('track', 'FindLocation');
        }
    });

    // Schedule / Quote Form: Schedule / Lead
	var scheduleForm = $( '#gform_2' );
	scheduleForm.submit( function() {
        if(debug == true) { 
            if( $(this).hasClass('form-schedule-service') ) {
                console.log("FB event - Schedule, tracked");
            } else {
                console.log("FB event - Lead, tracked");
            }
        } else { 
            if( $(this).hasClass('form-schedule-service') ) {
                fbq('track', 'Schedule');
            } else {
                fbq('track', 'Lead');
            }
        }
    } );    

    // Event Continue Form: CompleteRegistration
    var continueEvent = $( '.ga-event-signup' );
    continueEvent.click( function() {
        if(debug == true) { 
            console.log("FB event - CompleteRegistration, tracked");
        } else { 
            fbq( 'track', 'CompleteRegistration');
        }
    });

    // Submit Application Event: SubmitApplication
    var careersForm = $('#gform_3');
    careersForm.submit( function() {
        if(debug == true) { 
            console.log("FB event - SubmitApplication, tracked");
        } else { 
            fbq( 'track', 'SubmitApplication');
        }
    });

    // Pay for Service Page load Event: AddPaymentInfo
    if (window.location.href.indexOf("pay-for-service") > -1) {
        if(debug == true) { 
            console.log("FB event - AddPaymentInfo, tracked");
        } else { 
            fbq( 'track', 'AddPaymentInfo');
        }
    }

});

